import { convertToIsoDateWithTimezone } from '@uturn/portal/utils/convert-to-iso-date-with-timezone';
import { DatePicker, FormControl, FormItem, FormMessage } from '@uturn/ui-kit';
import { type ControllerRenderProps, type FieldValues } from 'react-hook-form';

export const DateInput = ({
	field,
	placeholder,
}: {
	field: ControllerRenderProps<FieldValues, string>;
	placeholder?: string;
}) => {
	const iso = typeof field.value === 'string' ? field.value : '';
	const dateVal = iso ? new Date(iso) : undefined;

	return (
		<FormItem>
			<FormControl>
				<DatePicker
					ref={field.ref}
					value={dateVal}
					selected={dateVal}
					type="datetime"
					onSelect={(date) =>
						field.onChange(date ? convertToIsoDateWithTimezone(date) : '')
					}
					placeholderText={placeholder}
				/>
			</FormControl>
			<FormMessage />
		</FormItem>
	);
};
